import { civilities, HeritierType } from "../../static/types/commonTypes/individualType"
import PostalCodeField from "./PostalCodeField"
import useValidation from "../../hooks/useValidation"
import { useEffect } from "react"
import heritierValidationSchema from "../../utils/validation/heritierValidationSchema"

type heritierProps = {
    checkedHeritier: boolean,
    heritier: HeritierType,
    qualitiesOptions: string[],
    changeHeritier: (partialIndividual: Partial<HeritierType>) => void,
    onValidationChange: (isValid: boolean) => void
}

export default function Heritier({
    checkedHeritier,
    heritier,
    changeHeritier,
    onValidationChange,
    qualitiesOptions,
}: heritierProps) {

    const { errors, isValid } = useValidation(heritier, heritierValidationSchema)

    useEffect(() => {
        onValidationChange(isValid)
    }, [isValid, onValidationChange])

    return (
        <div className="mb-3 row">
            <div className="mb-3 row">
                <label htmlFor="quality" className="col-sm-2 col-form-label">Qualité</label>
                <div className="col-sm-4">
                    <select
                        className="form-select"
                        id="quality"
                        onChange={event => changeHeritier({ quality: event.target.value })}
                        value={heritier.quality}
                    >
                        {
                            qualitiesOptions.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                    </select>


                </div>

                <label htmlFor="civility" className="col-sm-2 col-form-label"> Civilité <strong className="text-danger">*</strong>  </label>

                <div className="col-sm-4">

                    <select
                        className={`form-control ${(checkedHeritier && errors.civility) ? 'is-invalid' : ''}`}
                        name="civility"
                        id="civility"
                        value={heritier.civility}
                        onChange={event => changeHeritier({ civility: event.target.value as "Monsieur" | "Madame" })}
                    >
                        {
                            civilities.map(option =>
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            )
                        }

                    </select>
                    {(checkedHeritier && errors.civility) && <div className="invalid-feedback"> {errors.civility} </div>}

                </div>
            </div>

            <div className="mb-3 row">

                <label htmlFor="lastName" className="col-sm-2 col-form-label">Nom <strong className="text-danger">*</strong> </label>

                <div className="col-sm-4">

                    <input
                        className={`form-control ${(checkedHeritier && errors.lastName) ? 'is-invalid' : ''}`}
                        type="text"
                        name="nom"
                        id="lastName"
                        value={heritier.lastName}
                        onChange={event => changeHeritier({ lastName: event.target.value })}

                    />
                    {(checkedHeritier && errors.lastName) && <div className="invalid-feedback"> {errors.lastName} </div>}

                </div>

                <label htmlFor="birthName" className="col-sm-2 col-form-label">Nom de naissance</label>
                <div className="col-sm-4">
                    <input
                        className="form-control"
                        type="text"
                        name="birthName"
                        id="birthName"
                        value={heritier.birthName}
                        onChange={event => changeHeritier({ birthName: event.target.value })}

                    />
                </div>



            </div>

            <div className="mb-3 row">

                <label htmlFor="firstName" className="col-sm-2 col-form-label">Prénom <strong className="text-danger">*</strong> </label>

                <div className="col-sm-4">

                    <input
                        className={`form-control ${(checkedHeritier && errors.firstName) ? 'is-invalid' : ''}`}
                        type="text"
                        name="firstName"
                        value={heritier.firstName}
                        onChange={event => changeHeritier({ firstName: event.target.value })}
                    />
                    {(checkedHeritier && errors.firstName) && <div className="invalid-feedback"> {errors.firstName} </div>}

                </div>

                <label htmlFor="address" className="col-sm-2 col-form-label">Adresse <strong className="text-danger">*</strong> </label>

                <div className="col-sm-4">

                    <input
                        className={`form-control ${(checkedHeritier && errors.address) ? 'is-invalid' : ''}`}
                        type="text"
                        name="address"
                        id="address"
                        value={heritier.address}
                        onChange={event => changeHeritier({ address: event.target.value })}
                    />
                    {(checkedHeritier && errors.address) && <div className="invalid-feedback"> {errors.address} </div>}

                </div>



            </div>

            <div className="mb-3 row">
                <label htmlFor="additionalAddress" className="col-sm-2 col-form-label">Adresse suite</label>

                <div className="col-sm-4">
                    <input
                        className="form-control"
                        type="text"
                        name="additionalAddress"
                        value={heritier.additionalAddress}
                        onChange={event => changeHeritier({ additionalAddress: event.target.value })}
                    />
                </div>

                <label htmlFor="profession" className="col-sm-2 col-form-label">Profession <strong className="text-danger">*</strong> </label>
                <div className="col-sm-4">
                    <input
                        className={`form-control ${(checkedHeritier && errors.profession) ? 'is-invalid' : ''}`}
                        type="text"
                        name="profession"
                        value={heritier.profession}
                        onChange={event => changeHeritier({ profession: event.target.value })}
                    />
                    {(checkedHeritier && errors.profession) && <div className="invalid-feedback"> {errors.profession} </div>}
                </div>

            </div>
            <PostalCodeField
                checked={checkedHeritier}
                onChange={changeHeritier}
                postalCode={heritier.postalCode}
                errors={errors}
            />
            <div className="mb-3 row">
                <label htmlFor="city" className="col-sm-2 col-form-label">Ville <strong className="text-danger">*</strong> </label>
                <div className="col-sm-4">
                    <select
                        className={`form-control ${(checkedHeritier && errors.city) ? 'is-invalid' : ''}`}
                        name="city"
                        id="city"
                        onChange={event => changeHeritier({ city: event.target.value })}
                    >
                        {
                            heritier.cities?.map((city, key) =>
                                <option key={key} value={city}>
                                    {city}
                                </option>
                            )
                        }
                    </select>
                    {(checkedHeritier && errors.city) && <div className="invalid-feedback"> {errors.city} </div>}
                </div>





            </div>
        </div>
    )
}